import React, { useEffect } from 'react';
import './landing.css';
import './legal.css';

// ── LegalPage ─────────────────────────────────────────────────────────────────
// The shell shared by the public legal pages (/privacy, /terms). Public: no session, no auth gate.
// Reuses the landing page's footer classes and the site's tokens; introduces no new visual design.
export const LEGAL_CONTACT_EMAIL = 'hola@3aimigos.com';
export const LEGAL_COMPANY = '3AImigos LLC';
export const LEGAL_BRAND = '3AImigos';
export const LEGAL_SITE = 'https://www.3aimigos.com';

export default function LegalPage({ title, effective, current, children }) {
  useEffect(() => {
    const prev = document.title;
    document.title = `${title} · ${LEGAL_BRAND}`;
    window.scrollTo(0, 0);
    return () => { document.title = prev; };
  }, [title]);

  return (
    <div className="legal-page">
      <nav className="legal-nav" aria-label="Site">
        <div className="legal-nav-inner">
          <a className="legal-brand" href="/">{LEGAL_BRAND}</a>
          <div className="legal-nav-links">
            <a href="/privacy" aria-current={current === 'privacy' ? 'page' : undefined}>Privacy Policy</a>
            <a href="/terms" aria-current={current === 'terms' ? 'page' : undefined}>Terms &amp; Conditions</a>
            <a href="/sms-opt-in" aria-current={current === 'sms' ? 'page' : undefined}>Text opt-in</a>
          </div>
        </div>
      </nav>
      <main className="legal-main">
        <h1>{title}</h1>
        <p className="legal-meta">{LEGAL_COMPANY} · Effective {effective}</p>
        {children}
      </main>
      <footer className="lp-footer">
        <div className="lp-footer-inner">
          <div className="lp-footer-copy">© {new Date().getFullYear()} {LEGAL_BRAND}. All rights reserved.</div>
          <div className="lp-footer-links">
            <a className="lp-footer-link" href="/">Home</a>
            <a className="lp-footer-link" href="/privacy">Privacy</a>
            <a className="lp-footer-link" href="/terms">Terms</a>
            <a className="lp-footer-link" href={`mailto:${LEGAL_CONTACT_EMAIL}`}>{LEGAL_CONTACT_EMAIL}</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
